import { Grid, TextField, TextFieldProps } from '@mui/material';
import { AccessoryType } from '@smart-home/common';
import { FC, useCallback } from 'react';
import { FieldErrors, FieldValues, UseFormReturn } from 'react-hook-form';
import PermitJoin from '../../components/PermitJoin';

type XiaomiTempSensorAccessoryProps = {
  field?: string;
} & UseFormReturn<XiaomiTempSensorAccessoryFormModel>;

const muiErrors = <T extends FieldValues>(errors: FieldErrors<T>, name: keyof T): Pick<TextFieldProps, 'error' | 'helperText'> => ({
  error: !!errors[name],
  helperText: errors[name]?.message as string,
});

export type XiaomiTempSensorAccessoryFormModel = {
  alias: string;
  topic: string;
  id: string;
  type: AccessoryType;
};

const XiaomiTempSensorAccessoryForm: FC<XiaomiTempSensorAccessoryProps> = (props) => {
  const { register, formState: { errors }, setValue } = props;

  const onDiscovery = useCallback((deviceId: string) => {
    setValue('id', deviceId, { shouldTouch: true });
  }, [setValue]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          label="Alias"
          fullWidth
          error={!!errors.alias}
          helperText={errors.alias?.message}
          autoComplete="off"
          {...muiErrors(errors, 'alias')}
          {...register('alias')}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Topic"
          fullWidth
          disabled
          error={!!errors.topic}
          helperText={errors.topic?.message}
          autoComplete="off"
          {...muiErrors(errors, 'topic')}
          {...register('topic')}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Id"
          fullWidth
          error={!!errors.id}
          helperText={errors.id?.message}
          autoComplete="off"
          {...muiErrors(errors, 'id')}
          {...register('id')}
        />
        <PermitJoin onDiscovery={onDiscovery} />
      </Grid>
    </Grid>
  );
};

export default XiaomiTempSensorAccessoryForm;
